import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation, useParams, Outlet } from "react-router-dom";
import {
	ContentContainer,
	ContentGroup,
	createDialog,
	QuestionDialog,
} from "coaz-ui";
import { PiStudentLight } from "react-icons/pi";
import { GlobalContext } from "../contexts/GlobalContext";
import client from "../client";
import LoadingIcons from "react-loading-icons";
import Card from "./Card";
import ResponsiveChildren from "./ResponsiveChildren";

const Students = () => {
	const { version, setVersion } = useContext(GlobalContext);
	const [user,setUser] = useState(null);
	const [currentPrograms, setCurrentPrograms] = useState([]);
	const [availablePrograms, setAvailablePrograms] = useState([]);
	const [loading, setLoading] = useState(true);

	const { programId } = useParams();
	const navigate = useNavigate();
	const path = useLocation().pathname;
	const { request, getCurrent, errorMessage } = client;

	const load = async () => {
		setLoading(true);

		let currentUser = null;

		try {
			currentUser = await getCurrent();
		} catch (error) {
			console.log(error);
			return;
		}

		if (!currentUser && !currentUser.user) return;

		setUser(currentUser.user);

		let current = [];

		try {
			current = await request("GET", "students/by-user", null, {userReference: currentUser.user.ref.value,})
		} catch (error) {
			console.log(error);
		}

		let available = [];

		try {
			available = await request("GET", "students/available", null, {userReference: currentUser.user.ref.value,});
		} catch (error) {
			console.log(error);
		}

		setCurrentPrograms(current);
		setAvailablePrograms(available);
		setLoading(false);
	};

	useEffect(() => {
		load();
	}, [version]);

	const onOpen = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		navigate(`${path}/_program/${id}`)
	};

	const onEnroll = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		createDialog({
			title: "Enroll",
			submitText: "Yes",
			cancelText: "No",
			Component: QuestionDialog,
			params: {
				message: `Are you sure you want to enroll?`,
				submit: async () => {
					try {
						await request("POST", "students", null, {
							userReference:user.ref.value,
							programId: id,
						});
						return { message: "Successful", success: true };
					} catch (error) {
						return { message: errorMessage(error) };
					}
				},
			},
			version: version,
			setVersion: setVersion,
		});
	};

	const onUnenroll = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		createDialog({
			title: "Unenroll",
			submitText: "Yes",
			cancelText: "No",
			Component: QuestionDialog,
			params: {
				message: `Are you sure you want to unenroll?`,
				submit: async () => {
					try {
						await request("DELETE", "students", null, {
							userReference:user.ref.value,
							programId: id,
						});
						return { message: "Successful", success: true };
					} catch (error) {
						return { message: errorMessage(error) };
					}
				},
			},
			version: version,
			setVersion: setVersion,
		});
	};

	if (programId) return <Outlet />;

	return (
		<ContentContainer
			Icon={PiStudentLight}
			text={`${user?.firstname ?? ""} ${user?.lastname ?? ""}`}
			scrollable={true}
			loading={loading}
		>
			<div className="flex flex-col space-y-4">
				{currentPrograms.length > 0 && (
					<ContentGroup name="Current Programs">
						<ResponsiveChildren>
							{currentPrograms.map((program, index) => (
								<Card
									key={program?.program?.ref?.id ?? index}
									id={program?.program?.ref?.id ?? index}
									heading={program?.program?.name}
									body={program?.program?.description}
									image={`${process.env.PUBLIC_URL}/images/student.jpg`}
									onOpen={onOpen}
									actionText="Unenroll"
									onAction={onUnenroll}
								/>
							))}
						</ResponsiveChildren>
					</ContentGroup>
				)}

				{availablePrograms.length > 0 && (
					<ContentGroup name="Available Programs">
						<ResponsiveChildren>
							{availablePrograms.map((program, index) => (
								<Card
									key={program.ref?.id ?? index}
									id={program.ref?.id ?? index}
									heading={program.name}
									body={program.description}
									image={`${process.env.PUBLIC_URL}/images/program.jpg`}
									actionText="Enroll"
									onAction={onEnroll}
								/>
							))}
						</ResponsiveChildren>
					</ContentGroup>
				)}
			</div>
		</ContentContainer>
	);
};

export default Students;
